import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';

/**
 * Modern functional route configuration
 * Replaces RouterModule.forRoot() with standalone components
 */
export const routes: Routes = [
  {
    path: 'Login',
    loadChildren: () => import('./features/auth/login/login.routes').then((m) => m.LOGIN_ROUTES),
  },
  {
    path: '',
    canActivate: [authGuard],
    loadChildren: () => import('./features/dashboard/dashboard.routes').then((m) => m.DASHBOARD_ROUTES),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
